import {
    DIC
} from '@/const/dic'
import {
    validateChinese,
    validatenum,
    validateCapitalUnderline
} from '@/util/validate'


const validateName = (rule, value, callback) => {
    if (!validateChinese(value) || value.length > 30 || value.length < 1) {
        callback(new Error('分类名称为1-30位中文'))
    } else {
        callback();
    }
}

const validateCode = (rule, value, callback) => {
    if (!validateCapitalUnderline(value) || value.length > 50 || value.length < 1) {
        callback(new Error('分类编码为1-30位大写字母加下划线组成'))
    } else {
        callback();
    }
}
const validateNumber = (rule, value, callback) => {
    if (!validatenum(value)) {
        callback(new Error('请输入正确的整数数值'))
    } else {
        callback();
    }
}
export const classifyTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        /* {
            label: "分类编码",
            prop: "code",
            search: true,
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateCode
            }]
        }, */
        {
            label: "分类名称",
            prop: "name",
            type: "input",
            search: true,
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateName
            }]
        },
        {
            label: "一级分类",
            prop: "superiorId",
            solt: true,
            formsolt: true
        },
        {
            label: "排序",
            prop: "sort",
            type: "number",
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateNumber
            }]
        },
        {
            label: "类目图片",
            prop: "image",
            span: 24,
            overHidden: true,
            solt: true,
            formsolt: true,
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "radio",
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.STATE
        },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            hide: true,
            span: 24,
            max: 255
        }
    ]
};